import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_ACCTAG,
  DELETE_ACCTAG,
  UPDATE_ACCTAG,
  ADD_NEW_ACCTAG,
} from "./actionType";

import {
  getAccTagSuccess,
  getAccTagFail,
  deleteAccTagSuccess,
  deleteAccTagFail,
  updateAccTagSuccess,
  updateAccTagFail,
  addAccTagSuccess,
  addAccTagFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  getAccTagApi,
  updateAccTagApi,
  deleteAccTagApi,
  addNewAccTagApi
} from "../../helpers/backend_helper";

function* getAccTag({ payload: accTag }) {
  try {
    const response = yield call(getAccTagApi, accTag);
    yield put(getAccTagSuccess(GET_ACCTAG, response.data));
  } catch (error) {
    yield put(getAccTagFail(GET_ACCTAG, error));
  }
}

function* onUpdateAccTag({ payload: accTag }) {
  try {
    const response = yield call(updateAccTagApi, accTag);
    yield put(updateAccTagSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(updateAccTagFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteAccTag({ payload: accTag }) {
  try {
    const response = yield call(deleteAccTagApi, accTag);
    yield put(deleteAccTagSuccess({ accTag, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteAccTagFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewAccTag({ payload: accTag }) {
  try {
    const response = yield call(addNewAccTagApi, accTag);
    yield put(addAccTagSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addAccTagFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetAccTag() {
  yield takeEvery(GET_ACCTAG, getAccTag);
}

export function* watchUpdateAccTag() {
  yield takeEvery(UPDATE_ACCTAG, onUpdateAccTag);
}

export function* watchDeleteAccTag() {
  yield takeEvery(DELETE_ACCTAG, onDeleteAccTag);
}

export function* watchAddNewAccTag() {
  yield takeEvery(ADD_NEW_ACCTAG, onAddNewAccTag);
}

function* accTagSaga() {
  yield all([
    fork(watchGetAccTag),
    fork(watchDeleteAccTag),
    fork(watchUpdateAccTag),
    fork(watchAddNewAccTag)
  ]);
}

export default accTagSaga;
